exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.exbonus-table[data-v-74fa88aa] {\n    border-collapse: separate;\n    border: 1px solid rgba(0, 0, 0, 0.125);\n    border-radius: 0.25rem;\n}\n.center-items[data-v-74fa88aa] {\n    width: 100%;\n    margin: 0 auto;\n}\n.aube_user_wallet_check_color[data-v-74fa88aa] {\n    color: #450080;\n}\n.hec_saving_check_color[data-v-74fa88aa] {\n    color: #00ad69;\n}\n.check_color_position[data-v-74fa88aa] {\n    text-align: left;\n}\n/*スマホ用css*/\n@media screen and (max-width: 479px) {\n.td-amount[data-v-74fa88aa] {\n        overflow-wrap: anywhere !important;\n        width: 50px !important;\n}\n}\n", ""]);

// exports
